module.exports = __webpack_public_path__ + "img/attachment-word.1915603e.svg";